import { $, GraphQLTypes, InputType, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';

const trackingInfoSelector = Selector('TrackingInfo')({
  id: true,
  activityOrder: true,
  activityType: true,
  answers: true,
  isCorrect: true,
  time: true,
});

export const GQL_CREATE_TRACKING = typedGql('mutation')({
  createTracking: [
    {
      createTrackingInput: {
        trackingThematiqueId: $('trackingThematiqueId', 'Int!'),
        activityOrder: $('activityOrder', 'Int!'),
        activityType: $('activityType', 'ActivityType!'),
        answers: $('answers', '[String!]!'),
        isCorrect: $('isCorrect', 'Boolean!'),
        time: $('time', 'Int!'),
      },
    },
    trackingInfoSelector,
  ],
});

export type StoredTrackingInfo = InputType<
  GraphQLTypes['TrackingInfo'],
  typeof trackingInfoSelector
>;
